/**
 * Returns the value at the object path
 *
 * @param {Object} object
 * @param {String} path - The path to the value
 * @param {any} defaultValue - Default value to be returned
 * @returns {any}
 */
export default function get(object, path, defaultValue = null) {
  const pathArray = typeof path === 'string' ? path.split('.') : path;
  return pathArray.reduce((xs, x) => (xs && xs[x] ? xs[x] : defaultValue), object);
}
